import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, authHeaders, apiErr } from './adminApi';
import BannerForm from './BannerForm';

const AdminBanner = ({ onUnauthorized }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ enabled: false, message: '', starts_at: '', ends_at: '', scope: 'all_pages', link_text: '', link_url: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/api/banner`);
      setForm({
        enabled: Boolean(data.enabled),
        message: data.message || '',
        starts_at: data.starts_at || '',
        ends_at: data.ends_at || '',
        scope: data.scope || 'all_pages',
        link_text: data.link_text || '',
        link_url: data.link_url || '',
      });
    } catch (err) {
      toast.error(`Failed to load: ${apiErr(err)}`);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // API is a module-scoped import and stable

  useEffect(() => { load(); }, [load]);

  const put = async (payload, successMsg, errPrefix) => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/banner`, payload, { headers: authHeaders() });
      toast.success(successMsg);
      await load();
    } catch (err) {
      if (err?.response?.status === 401) onUnauthorized();
      else toast.error(`${errPrefix}: ${apiErr(err)}`);
    } finally {
      setSaving(false);
    }
  };

  const save = () => put({
    enabled: form.enabled,
    message: form.message,
    starts_at: form.starts_at || null,
    ends_at: form.ends_at || null,
    scope: form.scope,
    link_text: form.link_text || null,
    link_url: form.link_url || null,
  }, form.enabled ? 'Announcement is live' : 'Announcement saved', 'Save failed');

  const disableNow = () => put({ enabled: false }, 'Banner hidden', 'Disable failed');

  return (
    <section data-testid="admin-banner-tab">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold">Site banner</h2>
        <p className="text-sm text-gray-400">A red banner that appears above every page to announce closures or special hours.</p>
      </div>
      {loading
        ? <p className="text-gray-400">Loading…</p>
        : <BannerForm form={form} setForm={setForm} saving={saving} onSave={save} onDisable={disableNow} />}
    </section>
  );
};

export default AdminBanner;
